import * as signalR from '@aspnet/signalr'
const signal = new signalR.HubConnectionBuilder()　　　//服务器地址
    .withUrl("/lchub/signalr",{})
    .build()
    export default {
        install: function(Vue) {
            Vue.prototype.signalr = signal
        }
    }